import { CoreModule } from '@abp/ng.core';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { NgModule } from '@angular/core';
import { CommercialUiModule } from '@volo/abp.commercial.ng.ui';
import { ThemeSharedModule } from '@abp/ng.theme.shared';
import { NgxValidateCoreModule } from '@ngx-validate/core';
import { SpinnerComponent } from './spinner/spinner.component';
import { TawkToComponent } from './tawk-to/tawk-to.component';
import { FullNamePipe } from './pipes/full-name.pipe';
import { FindByIdPipe } from './pipes/find-by-id.pipe';

@NgModule({
  declarations: [
    SpinnerComponent,
    TawkToComponent,
    FullNamePipe,
    FindByIdPipe
  ],
  imports: [
    CoreModule,
    ThemeSharedModule,
    CommercialUiModule,
    NgbDropdownModule,
    NgxValidateCoreModule
  ],
  exports: [
    CoreModule,
    ThemeSharedModule,
    CommercialUiModule,
    NgbDropdownModule,
    NgxValidateCoreModule,
    SpinnerComponent,
    TawkToComponent,
    FullNamePipe,
    FindByIdPipe
  ],
  providers: []
})
export class SharedModule {}
